/**
 * Holds the keys for our local storage access.
 *
 * File: \src\components\general\storage\LocalStorageKeys.ts
 * Created Date: Thursday, March 28th 2019, 10:54:36
 * Author: Sascha Herrmann
 * -----
 * Last Modified: February 9th 2020, 18:49:27
 * Modified By: Sascha Herrmann
 * -----
 * Copyright (c) 2017-2019 Liebherr-Hausgeräte GmbH
 */

/**
 * This class just holds the keys for access to our local storage.
 *
 * @export
 * @class LocalStorageKeys
 */
export default class LocalStorageKeys {
  /** The key that we use for storing the user language. */
  public static readonly LOCAL_STORAGE_LANGUAGE_KEY = 'language';
}
